import { useParams } from 'react-router-dom'
import ReelViewer from '../components/ReelViewer/ReelViewer'

export default function Category() {
  const { slug } = useParams<{ slug: string }>()

  return (
    <main className="min-h-screen">
      <ReelViewer categorySlug={slug || ''} />
    </main>
  )
}
